export default "__VITE_ASSET__Cajfxfjv__"